import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faAdd } from '@fortawesome/pro-solid-svg-icons';
import { Button as ButtonAtom, ButtonProps } from '@rocketlane/ui';
import { Tooltip } from 'antd';
import { FC, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Button = styled(ButtonAtom).attrs({
  variant: 'ghost',
  size: 'medium',
  leftIcon: <FontAwesomeIcon icon={faAdd} size={12} />,
})`
  background-color: var(--blue-10) !important;

  &:hover {
    background-color: var(--blue-20) !important;
  }
`;

export const AddButton: FC<ButtonProps> = ({ onClick, ...props }) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const handleButtonClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      setTooltipVisible(false);
      onClick?.(e);
    },
    [onClick],
  );

  return (
    <Tooltip
      title={
        <FormattedMessage id="rich_text_editor.sections.add_block.trigger.tooltip" />
      }
      placement="left"
      open={tooltipVisible}
      onOpenChange={setTooltipVisible}
      trigger={['hover', 'focus']}
    >
      <Button onClick={handleButtonClick} {...props} />
    </Tooltip>
  );
};
